export { default as translations } from './translations.json';

export const MAX_PROPOSALS = 10;
export const REMINDER_DELAY_HOURS = 24;

/**
 * Get abandoned proposals from user.
 * @param {Object|null} user
 * @returns {Object[]}
 */
export const getAbandonedProposals = (user) =>
  user?.attributes?.profile?.privateData?.abandonedProposals || [];

/**
 * Get abandoned proposal for a specific listing.
 * @param {Object|null} user
 * @param {string} listingId
 * @returns {Object|null}
 */
export const getProposalForListing = (user, listingId) =>
  getAbandonedProposals(user).find(p => p.listingId === listingId) || null;

/**
 * Check if a proposal needs a reminder (started > REMINDER_DELAY_HOURS ago, not yet reminded).
 * @param {Object} proposal
 * @param {Date} [now]
 * @returns {boolean}
 */
export const needsReminder = (proposal, now = new Date()) => {
  if (!proposal || proposal.remindedAt) return false;
  const hoursElapsed = (now - new Date(proposal.startedAt)) / (1000 * 60 * 60);
  return hoursElapsed >= REMINDER_DELAY_HOURS;
};
